module.exports = __webpack_public_path__ + "img/landcruiser.cfe63273.png";